import type { ActionData } from "~/routes/__auth/login";
import { EmailPasswordForm } from "./components/EmailPasswordForm";
import { JustResetPasswordToast } from "./components/JustResetPasswordToast";
import { OtpForm } from "./components/OtpForm";

type Props = {
  isLoading: boolean;
  justResetPassword?: boolean;
  actionData?: ActionData;
};

export const LoginPage: React.FC<Props> = (props) => {
  const isLoading = props.isLoading;

  return (
    <>
      {props.actionData?.step !== "otp" ? (
        <EmailPasswordForm
          isLoading={isLoading}
          error={props.actionData?.error}
        />
      ) : (
        <OtpForm
          isLoading={isLoading}
          backendSessionId={props.actionData.backendSessionId}
          otpType={props.actionData.otpType}
          userId={props.actionData.userId}
          email={props.actionData.email}
          is2FA={props.actionData.otpType === "totp"}
          error={props.actionData.error}
        />
      )}
      {props.justResetPassword ? <JustResetPasswordToast /> : null}
    </>
  );
};
